import { render, staticRenderFns } from "./ProcessSidebarMainTab.vue?vue&type=template&id=3975b2cc&scoped=true"
import script from "./ProcessSidebarMainTab.vue?vue&type=script&lang=js"
export * from "./ProcessSidebarMainTab.vue?vue&type=script&lang=js"
import style0 from "./ProcessSidebarMainTab.vue?vue&type=style&index=0&id=3975b2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975b2cc",
  null
  
)

export default component.exports